import { Link } from 'react-router-dom'

export default function NotFoundPage() {
  return (
    <div style={{minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',flexDirection:'column',gap:'var(--space-4)',background:'var(--color-cream)',padding:'var(--space-8)',textAlign:'center'}}>
      <div style={{fontSize:80,fontWeight:700,color:'var(--color-navy)',fontFamily:'var(--font-display)',opacity:0.15}}>404</div>
      <h1 style={{fontFamily:'var(--font-display)',fontSize:'var(--text-4xl)',color:'var(--color-navy)'}}>Page Not Found</h1>
      <p style={{color:'var(--color-gray-500)',maxWidth:400}}>The page you're looking for doesn't exist or you may not have permission to view it.</p>
      <Link to="/app/dashboard" style={{background:'var(--color-navy)',color:'white',padding:'var(--space-3) var(--space-8)',borderRadius:'var(--radius-full)',fontWeight:600,fontSize:'var(--text-sm)'}}>
        Return to Dashboard
      </Link>
    </div>
  )
}
